import { render, staticRenderFns } from "./TabMenuItem.vue?vue&type=template&id=9a6c975c&scoped=true&"
import script from "./TabMenuItem.vue?vue&type=script&lang=js&"
export * from "./TabMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TabMenuItem.vue?vue&type=style&index=0&id=9a6c975c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c975c",
  null
  
)

export default component.exports